import { generateApplicationUrl } from '@domain-group/javascript-utils'

type GenerateMediaReviewerUrlParams = {
  campaignId: number,
  providerId: number,
}

export const generateMediaReviewerUrl = (params: GenerateMediaReviewerUrlParams) => {
  const { campaignId, providerId } = params

  const mediaReviewerModalPayload = encodeURIComponent(
    JSON.stringify({ campaign: { id: campaignId }, provider: { id: providerId } }),
  )

  // @ts-expect-error TS2339
  const { applicationUrlWithHash } = generateApplicationUrl({
    applicationKey: 'realhub',
    // @ts-expect-error TS2322
    environment: process.env.REACT_APP_APPLICATION_ENV,
    hash: `/#/campaigns/${campaignId}/edit/media?showModal=MediaReviewerModal&showModalPayload=${mediaReviewerModalPayload}`,

  })

  return applicationUrlWithHash
}

export default generateMediaReviewerUrl
